import { makeStyles } from '@mui/styles';
import { display } from '@mui/system';
import { NodeNextResponse } from 'next/dist/server/base-http/node';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  mainContainer: {
    width: '100%',
    position: 'fixed',
    bottom: '0',
    display: 'flex',
    backgroundColor: theme.palette.cinnamon.main,
    padding: '10px 25px',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: '5px',
    zIndex: 5,
    [theme.breakpoints.down(400)]: {
      padding: '10px 15px',
    },
  },

  bottomContainer: {
    flexShrink: 0,
    width: '100%',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down(360)]: {
      padding: '10px 15px',
    },
  },

  bottomLowerContainer: {
    padding: '10px 25px',
    backgroundColor: theme.palette.cinnamon.main,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    columnGap: '5px',
  },

  drawerConatiner: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.cinnamon.main,
    position: 'sticky',
    top: 0,
    zIndex: 999,
  },

  cartOpenBtn: {
    width: '120px',
    height: '48px',
    border: `2px solid ${theme.palette.whitePepper.main}`,
    borderRadius: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '10px',
  },

  cartCount: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '15px',
  },

  mealCount: {
    width: '100%',
    padding: '10px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '10px',
  },

  myBoxWrapper: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },

  dishWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    rowGap: '8px',
  },

  dish: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  sizeFreqEmptyTextWrapper: {
    padding: '0px 15px 15px',
    display: 'flex',
    align: 'center',
    justifyContent: 'space-between',
  },

  checkoutBtn: {
    position: 'fixed',
    bottom: '0',
    zIndex: 10,
  },

  emptyBox: {
    padding: '30px 25px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.whitePepper.main,
  },

  contentShow: {
    padding: '50px 25px',
    width: '100%',
    minHeight: 'calc(100vh - 86px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.whitePepper.main,
  },

  seeFullMenuWrapper: {
    margin: '45px 0 30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  seeFullMenuBtnWrapper: {
    textTransform: 'none',
    borderRadius: '55px',
    border: `2px solid ${theme.palette.cinnamon.main}`,
    width: '300px',
    height: '50px',
    '&:hover': {
      backgroundColor: theme.palette.whitePepper.main,
      borderColor: theme.palette.cinnamon.main,
    },
  },

  notSureWrapper: {
    marginTop: '30px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  wrapper: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  mealWrapper: {
    flexGrow: 1,
    overflowY: 'auto',
    /* width */
    '&::-webkit-scrollbar': {
      width: '6px',
    },

    /* Track */
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.turmeric.main,
      borderRadius: '4px',
    },
  },

  mealContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    columnGap: '45px',
    rowGap: '50px',
  },

  //plan and freq

  btnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '50px',
    height: '90px',
    overflow: 'hidden',
  },

  savaAndContinueBtnWrapper: {
    position: 'fixed',
    bottom: '0px',
    width: '100%',
    cursor: 'pointer',
  },
});
